import { ApiResponse, UISchema, ParamDefRowView } from "@bonusmap/api-types";
import { isBonusParametersInput } from "../../types/BonusParameters.js";
import { PARAM_TYPE_MAP, PARAM_TYPE_VALUE_MAP } from "../../utils/lists.js";
export interface ParameterViewItem {
    name: string;
    description?: string;
    type: string;
    typeLabel?: string;
    typeValue: string; 
    typeValueLabel: string; 
    value: any;
    parameter_id: number;
}

/**
 * Questo helper si occupa di recuperare i dati relativi ai parametri bonus
 * trasformando gli ID dei parametri in dati leggibili con nome e tipo
 * Restituisce array di array per mantenere la struttura logica OR/AND
 */
export async function retrieveParameters(
    dataSource: UISchema,
    fieldName: string = "parameters"): Promise<ParameterViewItem[][]> {

    const uiField = dataSource[fieldName];
    if (!uiField) {
        return [];
    }

    const parametersData = uiField.value;
    if (!parametersData) {
        return [];
    }

    // Verifica se è già un formato valido BonusParametersInput
    if (!isBonusParametersInput(parametersData)) {
        return [];
    }

    // Normalizza sempre in formato array di array
    let normalizedData: Array<Array<{parameter_id: number, value: any}>>;
    if (Array.isArray(parametersData[0])) {
        // È già un array di array
        normalizedData = parametersData as Array<Array<{parameter_id: number, value: any}>>;
    } else {
        // È un array semplice, lo trasformiamo in array di array
        normalizedData = [parametersData as Array<{parameter_id: number, value: any}>];
    }

    const result: ParameterViewItem[][] = [];

    // Raccoglie tutti gli ID unici dei parametri
    const parameterIds = new Set<number>();
    normalizedData.forEach(group => {
        group.forEach(param => {
            parameterIds.add(param.parameter_id);
        });
    });

    // Recupera le informazioni dei parametri tramite API
    const parameterIdsArray = Array.from(parameterIds);
    const apiResponse: ApiResponse<any[]> = await window.api.manager.params.getByIdsView(parameterIdsArray);

    if (!apiResponse?.success || !apiResponse?.data) {
        return [];
    }

    // Crea una mappa per lookup veloce
    const parametersMap = new Map<number, ParamDefRowView>();
    apiResponse.data.forEach(param => {
        parametersMap.set(param.id, param);
    });

    // Costruisce il risultato finale come array di array
    normalizedData.forEach((group) => {
        const parameterItems: ParameterViewItem[] = [];

        group.forEach(paramData => {
            const paramInfo = parametersMap.get(paramData.parameter_id);
            if (paramInfo) {
                
                const typeValueLabel = PARAM_TYPE_VALUE_MAP[paramInfo.type_value as keyof typeof PARAM_TYPE_VALUE_MAP] || 'string';
                parameterItems.push({
                    name: paramInfo.name || `Parameter ${paramData.parameter_id}`,
                    description : paramInfo.description,
                    type: paramInfo.type_name || 'unknown',
                    typeLabel: PARAM_TYPE_MAP[paramInfo.type_name as keyof typeof PARAM_TYPE_MAP] || 'string',
                    typeValue:paramInfo.type_value,
                    typeValueLabel,
                    value: paramData.value,
                    parameter_id: paramData.parameter_id
                });
            }
        });

        if (parameterItems.length > 0) {
            result.push(parameterItems);
        }
    });

    return result;
}